function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { JSONTree } from "react-json-tree";
import { jsonTreeTheme } from "../theme";
export default function JSONTreeWrapper(props) {
  return /*#__PURE__*/React.createElement(JSONTree, _extends({
    invertTheme: false,
    theme: jsonTreeTheme,
    hideRoot: true
  }, props));
}